import React from 'react';
import cn from 'classnames';

import { printMissingConfigError, SiteConfigManager } from '@atlas/core';

import { PLATFORM_TYPES } from 'common/constants';

import FooterMenuList from './FooterMenuList';
import FooterMenuListItem from './FooterMenuListItem';
import { scrollToTopHandler } from './scrollToTopHandler';

const { DESKTOP, MULTIPLATFORM } = PLATFORM_TYPES;

const filterPlatformSpecificNav = nav =>
  nav.filter(el => el.platform_type === MULTIPLATFORM || el.platform_type === DESKTOP);

const FooterNavigationMenu = () => {
  const bottomNav = SiteConfigManager.getConfig('navigation.bottom', []);

  if (bottomNav.length === 0) {
    printMissingConfigError('navigation.bottom');
  }

  const filteredNavigation = filterPlatformSpecificNav(bottomNav);

  return (
    <div
      className={cn(
        'footer__menu',
        filteredNavigation.length === 1 && 'footer__menu--single-column',
      )}
    >
      {filteredNavigation.map(({ children, name }) => {
        const filteredChildren = filterPlatformSpecificNav(children);
        const childNavigation = filteredChildren.map(({ location, name }) => (
          <FooterMenuListItem
            key={name}
            location={location}
            name={name}
            onClick={scrollToTopHandler}
          />
        ));
        return (
          <FooterMenuList
            className={filteredNavigation.length === 1 ? 'footer__mennu--grow-0' : null}
            key={name}
            title={name}
          >
            {childNavigation}
          </FooterMenuList>
        );
      })}
    </div>
  );
};

export default FooterNavigationMenu;
